<template>
  <div class="starschermen">
    <subNav :subnavstep="subnavstep"></subNav>

    <div class="introtext">
      <h2 class="introtext__title">Welkom bij de ParticipatieWijzer</h2>
      <ul>
        <li>Vragen over jouw situatie en vraagstuk</li>
      </ul>
    </div>

    <div class="questiongroup">
      <button @click="onStartClicked" class="button button--wide">
        Stap 1: Jouw situatie
      </button>
    </div>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";
import storage from '../mixins/storage';

export default {
  mixins: [
    storage
  ],

  data() {
    return {
      subnavstep: "start",
    };
  },

  name: "uwSituatieStartscherm",

  wasOpened: false,

  components: {
    subNav,
  },

  methods: {    
    onStartClicked() {      
      _paq.push(["trackEvent", "userEvent", "situationStarted"]);
      this.$router.push({ name: "uw-situatie-initiatief" });
    },
  },

  computed: {},

  created() {
    this.clearStorage();
  },

  mounted() {    
  },
};
</script>

